import React from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";

import SettingsPanel from "../../components/SettingsPanel";

export default function CallsSettings() {
  // Dynamically grab the current domain
  const currentDomain = window.location.origin;

  return (
    <SettingsPanel
      title="Screen Pop Integration (VoIP)"
      description="Connect your VoIP provider so inbound calls pop the matching record"
    >
      <Box sx={{ px: 3, maxWidth: 800 }}>
        <Typography variant="body1" paragraph>
          You can integrate your VoIP system with this CRM using screen pop
          functionality. When configured, incoming calls will automatically open
          the corresponding contact or lead in the CRM, helping your team
          respond faster.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom fontWeight="medium">
          General Setup
        </Typography>
        <Typography variant="body2" paragraph>
          Set your VoIP screen pop URL to the following:
        </Typography>

        <Paper
          sx={{
            p: 2,
            bgcolor: "grey.100",
            mb: 2,
            borderLeft: "4px solid #1976d2",
          }}
        >
          <Typography
            variant="body2"
            component="code"
            sx={{ fontFamily: "monospace", fontSize: "1rem" }}
          >
            {currentDomain}/call-screen-pop/XXXXXX
          </Typography>
        </Paper>
        <Typography variant="body2" color="text.secondary" paragraph>
          <em>
            Note: Replace <strong>XXXXXX</strong> with the caller's phone
            number. Most VoIP systems will automatically insert this value using
            their own variable format.
          </em>
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="medium">
            Example: GoIntegrator
          </Typography>
          <Typography variant="body2" paragraph>
            If you are using GoIntegrator, you can configure the screen pop URL
            like this:
          </Typography>
          <Paper
            sx={{
              p: 2,
              bgcolor: "grey.100",
              mb: 2,
              borderLeft: "4px solid #2e7d32",
            }}
          >
            <Typography
              variant="body2"
              component="code"
              sx={{ fontFamily: "monospace", fontSize: "1rem" }}
            >
              {currentDomain}/call-screen-pop/%CALLERID%
            </Typography>
          </Paper>
          <Typography variant="body2" color="text.secondary">
            GoIntegrator will replace <code>%CALLERID%</code> with the incoming
            caller's number, allowing the CRM to display the correct record as
            soon as the call is received.
          </Typography>
        </Box>
      </Box>
    </SettingsPanel>
  );
}
